/**
 * @author Jersson Morales
 * @Copyright (c) Infotrack. All rights reserved.
 */
import ProveedorEstado from '@infotrack/presentacion-componentes/proveedorEstado';
import React from 'react';
import FormualrioPaisCV from './controladorVista/formularioPaisCV';
import TablaPaisCV from './controladorVista/tablaPaisCV';
import { estadoIncial, reductor } from './reductorPais';

const Pais: React.FunctionComponent = () => (
    <ProveedorEstado estadoInicial={estadoIncial} reductor={reductor}>
        <TablaPaisCV />
        <FormualrioPaisCV />
    </ProveedorEstado>
);

export default Pais;
